// ─── Request serializer ───────────────────────────────────────────
// Some shared-hosting plans allow only ONE concurrent request into the app
// (CloudLinux EP limit). When the browser fires several API calls at once
// (e.g. the dashboard), the extras get a 503 "temporarily busy". This limiter
// funnels all API calls through a queue so at most MAX hit the server at a time.
const MAX = 1;
let running = 0;
const queue: Array<() => void> = [];

export function acquireSlot(): Promise<void> {
  if (running < MAX) {
    running++;
    return Promise.resolve();
  }
  return new Promise<void>((resolve) => queue.push(resolve)).then(() => {
    running++;
  });
}

export function releaseSlot(): void {
  running = Math.max(0, running - 1);
  const next = queue.shift();
  if (next) next();
}
